import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=295969d0"
import script from "./ProjectList.vue?vue&type=script&lang=js"
export * from "./ProjectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295969d0')) {
      api.createRecord('295969d0', component.options)
    } else {
      api.reload('295969d0', component.options)
    }
    module.hot.accept("./ProjectList.vue?vue&type=template&id=295969d0", function () {
      api.rerender('295969d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/users/ProjectList.vue"
export default component.exports